import React from 'react';

export const textBreak = text => {
    if (text) {
        if (text.includes('/n')) {
            const paraArr = text.split('/n');
            return <div>
                {paraArr.map((p,i)=><p key={i}>{p}</p>)}
            </div>;
        } else {
            return <p>{text}</p>;
        }
    } else {
        return;
    }
}